import React, { useRef, useState } from 'react';
import { DEFAULT_API_URL } from '../../constents';
import uploadfiles from '../../Utilities/handleUploadFiles';
import setUiMessage from '../../Utilities/Tostify';

function UploadDocsSec({
  uploadCb,
  parentId,
  isScan = false,
  closeUploadPagePopup = () => {},
}) {
  const fileInputRef = useRef(null);
  const [showInputBox, setShowInputBox] = useState(false);
  const [encInputVal, setEncInputVal] = useState('');
  const [chkBoxVal, setChkBoxVal] = useState(0);

  const handleBrouseClick = () => {
    fileInputRef.current.click();
  };

  const handleCameraClick = () => {
    fileInputRef.current.setAttribute('capture', 'camera');
    fileInputRef.current.click();
    fileInputRef.current.removeAttribute('capture');
  };

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (file) {
      if (chkBoxVal === 0 || (chkBoxVal === 1 && encInputVal !== '')) {
        const apiUrl = `${DEFAULT_API_URL}/api/patient/ManagePatientDocument/uploadDocument/${chkBoxVal}/${encInputVal}`;
        const responce = await uploadfiles(apiUrl, file);
        if (responce.data?.successCode === 'success') {
          uploadCb(
            {
              fileName: responce.data?.fileName,
              encrtption: responce.data?.hashCode,
              filePath: responce.data?.filePathName,
            },
            parentId
          );
        }
      } else {
        setUiMessage('err', 'Please provide encryption password');
      }
      closeUploadPagePopup();
    } else {
      setUiMessage('err', 'Please select file');
    }
  };

  const handleEncriptInput = (e) => {
    setChkBoxVal(e.target.checked ? 1 : 0);
    if (e.target.checked) {
      setShowInputBox(true);
    } else {
      setShowInputBox(false);
    }
  };

  return (
    <div
      className="insu-act-sec-bdy-rw"
      style={{
        border: '1px solid #ccc',
        padding: '10px',
      }}
    >
      <div
        className="flex-sec"
        style={{ alignItems: 'center', justifyContent: 'flexStart' }}
      >
        <div
          className=""
          style={{
            margin: '4px 10px 0px 15px',
          }}
        >
          <input
            type="checkbox"
            className="inpt-chkbx"
            value={chkBoxVal}
            onChange={handleEncriptInput}
          />
        </div>
        <div
          className="italic sec-colr"
          style={{
            margin: '8px 0px 10px 0px',
          }}
        >
          Is this file encrypted and do you want to decrypt it before uploading
          ? (TRIPLEDES 168 bit)
        </div>
        {showInputBox && (
          <input
            type="text"
            value={encInputVal}
            className="inpt-width-nw"
            style={{ width: '100px', marginLeft: '10px' }}
            onChange={(e) => setEncInputVal(e.target.value)}
          />
        )}
      </div>

      <div className="nsu-act-val flex-sec">
        <span className="nsu-act-lbl bold">Upload:</span>
        <span
          className="actn-yes"
          style={{
            width: 'unset',
            padding: '3px 12px',
            marginLeft: '0px',
          }}
          onClick={handleCameraClick}
        >
          Camera
        </span>
        <span
          className="actn-yes"
          style={{ width: 'unset', padding: '3px 12px' }}
          onClick={handleBrouseClick}
        >
          Browse
        </span>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFileSelect}
        />
        {isScan && (
          <span
            className="actn-yes"
            style={{ width: 'unset', padding: '3px 12px' }}
          >
            Scan
          </span>
        )}
      </div>
    </div>
  );
}

export default UploadDocsSec;
